// Base styles
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";

const { md } = boxShadows;
const { borderRadius } = borders;

// types
type Types = any;

const tableContainer: Types = {
  styleOverrides: {
    root: {
      boxShadow: md,
      borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
